<script>
  import {mapActions} from 'vuex';
  import utilsService from 'src/services/UtilsService.js';
  import Password from 'vue-password-strength-meter';

  export default {
    components: {
      Password
    },
    props: ["value", "instance"],
    data() {
      return {
        payload: {
          currentPassword: '',
          newPassword: '',
          repeatNewPassword: '',
          user: {},
        },
        errors: [],
        context: null,
        successMessage: '',
        rules: {
          "currentPassword": [],
          "newPassword": [],
          "repeatNewPassword": []
        }
      }
    },
    watch: {
      "value": function(newValue, oldValue) {
        if(newValue) {
          this.payload.user = this.instance;
        }
      }
    },
    computed: {
      _value: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue);
        }
      }
    },
    methods: {
      ...mapActions([
        'changePassword',
        'updatePasswordExpired',
        'showLoader',
        'hideLoader'
      ]),
      resetData: function() {
        Object.assign(this.$data, this.$options.data());
      },
      close: function() {
        this._value = false;
        this.resetData();
      },
      save: function() {

        this.$refs["payload"].validate((valid) => {
          if (valid) {
            this.showLoader();
            this.changePassword(this.payload).then(response => {
              let code = response.meta.code;

              if(code == 200) {

                this.$notify({
                  title: this.$t("success"),
                  message: this.$t("savedPasswordWithSuccess"),
                  type: 'success'
                });

                this.close();
                this.updatePasswordExpired(response.data);
                return response.data;

              } else if (code === 400) {

                this.errors = utilsService.buildErrorMessage(response.errors);

                throw this.errors;
              }
            });

            this.hideLoader();
          } else {
            console.log('error submit!!');
          }
        });
      }
    },
    created: function () {
      if (this.rules) {

        this.rules["currentPassword"].push({required: true, message: this.$t('pleaseFillInTheField'), trigger: 'blur'});
        this.rules["newPassword"].push({required: true, message: this.$t('pleaseFillInTheField'), trigger: 'blur'});
        this.rules["repeatNewPassword"].push({required: true, message: this.$t('pleaseFillInTheField'), trigger: 'blur'});

        this.rules["newPassword"].push({
          validator: (rules, value, callback) => {
            if(this.payload.newPassword && (this.payload.newPassword == this.payload.currentPassword)){
              callback(new Error(this.$t('newPasswordCanNotBeEqualToACurrentPassword')));
            }
            callback();
          },
          trigger: 'blur'
        });

        this.rules["newPassword"].push({
          validator: (rules, value, callback) => {
            if(this.payload.currentPassword && (this.payload.currentPassword == this.payload.newPassword)){
              callback(new Error(this.$t('newPasswordCanNotBeEqualToACurrentPassword')));
            }
            callback();
          },
          trigger: 'blur'
        });

        this.rules["repeatNewPassword"].push({
          validator: (rules, value, callback) => {
            if(this.payload.repeatNewPassword && (this.payload.repeatNewPassword != this.payload.newPassword)){
              callback(new Error(this.$t('newPasswordAndRepeatPasswordAreDifferentValues')));
            }
            callback();
          },
          trigger: 'blur'
        });

        this.rules["repeatNewPassword"].push({
          validator: (rules, value, callback) => {
            if(this.payload.newPassword && (this.payload.newPassword != this.payload.repeatNewPassword)){
              callback(new Error(this.$t('newPasswordAndRepeatPasswordAreDifferentValues')));
            }
            callback();
          },
          trigger: 'blur'
        });
      }
    },
    mounted: function () {
      this.payload.user = this.instance;
    }
  }

</script>

<template>
  <el-dialog :title="$t('changePassword')" :visible.sync="_value" @close="close" id="modal">
    <el-form label-position="top" :rules="rules" :model="payload" ref="payload">
      <bootstrap-alert-errors :errors="errors"></bootstrap-alert-errors>
      <el-form-item :label="$t('currentPassword')" prop="currentPassword">
        <el-input type="password"
                  v-model="payload.currentPassword"
                  id="currentPassword">
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('newPassword')" prop="newPassword">
        <el-input type="password"
                  v-model="payload.newPassword"
                  id="newPassword">
        </el-input>
        <password v-model="payload.newPassword" :strength-meter-only="true" :secureLength="2"/>
      </el-form-item>

      <el-form-item :label="$t('repeatNewPassword')" prop="repeatNewPassword">
        <el-input type="password"
                  v-model="payload.repeatNewPassword"
                  id="repeatNewPassword">
        </el-input>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-button size="small"
                     @click.prevent="close()"
                     id="close">
            {{$t("close")}}
          </el-button>
          <el-button type="primary"
                     size="small"
                     @click.prevent="save()"
                     id="save">
            {{$t("save")}}
          </el-button>
        </el-col>
      </el-row>
    </el-form>

  </el-dialog>
</template>



// WEBPACK FOOTER //
// ChangePasswordDialogForm.vue?73bfcb4e